<template>
    <div>
        <v-container fluid grid-list-md>
            <v-layout row wrap>
                <v-flex xs12>
                    <v-card>
                        <v-card-title primary-title>
                            <h3 class="headline mb-0">Versorgungspunkte</h3>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" @click="addCheckpoint()"><v-icon left>fal fa-plus</v-icon> Versorgungspunkt hinzufügen</v-btn>
                        </v-card-title>
                        <v-card-text>
                            <v-layout row>
                                <v-flex xs12>
                                    <p class="">URL für den externen Zugang: <a href="https://app.drussen.de/checkpoint" target="_blank">https://app.drussen.de/checkpoint</a></p>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex :key="checkpoint.id" d-flex xs12 lg4 md6 xl3  v-for="checkpoint in checkpoints" class="mb-2">
                                    <v-card>
                                        <v-card-title primary-title>
                                            <h3 class="subheadline mb-0">{{ checkpoint.title }}</h3>
                                            <v-progress-linear :value="getCheckpointProgress(checkpoint)" :color="parseInt(getCheckpointProgress(checkpoint)) > 0 ? 'success' : 'error'"></v-progress-linear>
                                        </v-card-title>
                                        <v-card-text>
                                            <p>Passwort: {{ checkpoint.token }}</p>
                                            <p>{{ checkpoint.description }}</p>
                                          <p v-if="checkpoint.distanceToPreviousCheckpoint > 0">Entfernung vorheriger VP: {{ checkpoint.distanceToPreviousCheckpoint }}</p>
                                            <p>Kategorien: <v-chip v-for="category in getCategories(checkpoint)" :key="category.id">{{ category.title }}</v-chip></p>
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-btn @click="generatePdf(checkpoint)">PDF</v-btn>
                                            <v-btn :to="{name: 'checkpoints-participants', params: { token: checkpoint.token }}"><v-icon>fal fa-walking</v-icon></v-btn>

                                            <v-btn color="" @click="editCheckpoint(checkpoint)"><v-icon>fal fa-edit</v-icon></v-btn>
                                            <v-btn v-if="checkpoint.categories.length === 0" color="error" @click="deleteCheckpoint(checkpoint)"><v-icon>fal fa-trash</v-icon></v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
        <v-dialog max-width="450" v-model="checkpointDialog">
            <v-card>
                <v-card-text>
                    <v-container>
                        <v-layout row>
                            <v-flex xs12>
                                <h3 v-if="checkpoint.id === 0">Versorgungspunkt hinzufügen</h3>
                                <h3 v-else>Versorgungspunkt bearbeiten</h3>
                            </v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex xs12>
                                <v-text-field label="Name" v-model="checkpoint.title"></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex xs12>
                                <v-textarea label="Beschreibung/Hinweise" v-model="checkpoint.description"></v-textarea>
                            </v-flex>
                        </v-layout>
                      <v-layout row>
                        <v-flex xs12>
                          <v-text-field label="Abstand zum vorherigen Versorgungspunkt" v-model="checkpoint.distanceToPreviousCheckpoint" suffix="km" type="number"></v-text-field>
                        </v-flex>
                      </v-layout>
                        <v-layout row>
                            <v-flex xs12>
                                <v-checkbox label="Kleiner Versorgungspunkt" v-model="checkpoint.small"></v-checkbox>
                            </v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex xs12>
                                <v-checkbox label="Virtueller Versorgungspunkt" v-model="checkpoint.virtual"></v-checkbox>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="checkpointDialog = false" color="primary" flat>Schließen</v-btn>
                    <v-btn @click="saveCheckpoint()" color="primary" flat>Speichern</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import jsPDF from 'jspdf'
    import 'jspdf-autotable';
    import { qrcanvas } from 'qrcanvas';

    export default {
        components: {
        },
        computed: {
            event() {
                return this.$store.state.event
            },
            categories() {
                return this.$store.state.categories
            },
            checkpoints() {
                return this.$store.state.checkpoints
            },
            participants() {
                return this.$store.state.participants
            }
        },
        data: function () {
            return {
                checkpointDialog: false,
                defaultCheckpoint: {
                    id: 0,
                    title: '',
                    description: '',
                    categories: [],
                    small: false,
                    virtual: false,
                    distanceToPreviousCheckpoint: 0
                },
                checkpoint: {
                    id: 0,
                    title: '',
                    description: '',
                    categories: [],
                    small: false,
                    virtual: false,
                    distanceToPreviousCheckpoint: 0
                }
            }
        },
        methods: {
            addCheckpoint () {
                this.checkpoint = Object.assign({}, this.defaultCheckpoint)
                this.checkpointDialog = true
            },
            deleteCheckpoint(checkpoint) {
                this.$confirm('Soll der Versorgungspunkt ' + checkpoint.title + ' wirklich gelöscht werden? Der Versorgungspunkt wird aus allen Kategorien entfernt.').then(res => {
                    if (res) {
                        this.$store.dispatch('deleteCheckpoint', checkpoint)
                    }
                })
            },
            editCheckpoint (checkpoint) {
                this.checkpoint = checkpoint
                this.checkpointDialog = true
            },
            saveCheckpoint () {
                this.checkpoint.event = this.$store.state.event.token;
                this.$store.dispatch('updateCheckpoint', this.checkpoint)
                this.checkpointDialog = false
            },
            doesCheckpointHasRunningCategory (checkpoint) {
                let running = false
                let categories = this.getCategories(checkpoint)
                if (categories.length > 0) {
                    categories.forEach(category => {
                        if (category.startTime !== null) {
                            running = true
                        }
                    })
                }
                return running
            },
            getCheckpointProgress (checkpoint) {
                const participants = this.getParticipants(checkpoint)
                let finished = 0
                const max = participants.length
                if (participants.length > 0) {
                    participants.forEach(participant => {
                        if (participant.canceled === true) {
                            finished++
                        } else if (participant.timeEntries.find(time => time.checkpoint === checkpoint.id) !== undefined) {
                            finished++
                        }
                    })
                }
                return (finished/max*100).toFixed(0)
            },
            getCategories (checkpoint) {
                let categories = []
                if (checkpoint.categories.length > 0) {
                    checkpoint.categories.forEach(id => {
                        categories.push(this.categories.find(category => id === category.id))
                    })

                }
                return categories
            },
            getArrayOfCategoryIds (checkpoint) {
                let categories = []
                if (checkpoint.categories.length > 0) {
                    checkpoint.categories.forEach(id => {
                        categories.push(this.categories.find(category => id === category.id).id)
                    })

                }
                return categories
            },
            getParticipants(checkpoint) {
                const categories = this.getArrayOfCategoryIds(checkpoint)
                return this.participants.filter(participant => categories.includes(participant.category))
            },
            getCategoryById (categoryId) {
              return this.categories.find(category => category.id === categoryId)
            },
            generatePdf: function (checkpoint) {
                let participants = []
                const eventTitle = this.event.title
                this.getParticipants(checkpoint).forEach(participant => {
                  const category = this.getCategoryById(participant.category)
                        participants.push({
                            startNumber: participant.startNumber || '',
                            firstname: participant.firstname,
                            lastname: participant.lastname,
                            category: category.title,
                            description: participant.canceled === true ? 'Abgebrochen' : ''
                        })
                })
                participants.sort((a, b) => {
                    return a.startNumber - b.startNumber
                })
                let columns = [
                    {title: 'Startnummer', dataKey: 'startNumber'},
                    {title: 'Vorname', dataKey: 'firstname'},
                    {title: 'Nachname', dataKey: 'lastname'},
                    {title: 'Kategorie', dataKey: 'category'},
                    {title: 'Bemerkungen', dataKey: 'description'}
                ]
                let doc = new jsPDF({
                    orientation: 'landscape'
                })
                doc.autoTable(columns, participants, {
                    margin: {top: 25},
                    addPageContent: function () {
                        doc.text(eventTitle + ' - ' + checkpoint.title, 15, 15)
                    },
                    headerStyles: {
                        fillColor: [46, 126, 51]
                    }
                })

                let pageCount = doc.internal.getNumberOfPages();
                let date = new Date()
                let qrCode = new qrcanvas({
                  data: 'https://app.drussen.de/checkpoint/' + checkpoint.token,
                });
                for (let page = 1; page <= pageCount; page++) {
                    doc.setPage(page);
                    doc.setFontSize(8)
                    doc.text(10, 205, 'drussen.de - ' + date.toLocaleDateString('de-DE') + ' ' + date.toLocaleTimeString('de-DE'))
                    doc.text(80, 205, 'Versorgungspunkt Login über QR Code oder den folgenden Link https://app.drussen.de/checkpoint mit dem Passwort: ' + checkpoint.token)
                    doc.text(260, 205, 'Seite ' + (page) + ' von ' + pageCount)

                  doc.addImage(qrCode.toDataURL('image/png'), 'png', 270, 5, 18, 18)
                }
                window.open(doc.output('bloburi'));
                //doc.save(checkpoint.title + '.pdf')
            },
        }
    }
</script>

<style type="scss" scoped>
    .v-card {
        display: flex;
        justify-content: space-between;
        flex-direction: column;


    }
</style>
